import Service from "../../Services";

const MiniType = {
  namespaced : true,
  state : {
    form : {
      type_id : '',
      maker_color : '',
      type_name : '',
    }
  },
  mutations : {
    SET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        type_id : '',
        maker_color : '',
        type_name : '',
      }
    }
  },
  actions : {
    getMiniType({commit},page){
      return Service.TCDCMiniTypeAPI.getTCDCMiniType(page);
    },
    getAllMiniType({commit}){
      return Service.TCDCMiniTypeAPI.getAllMiniType();
    },
    showMiniType({commit},id){
      return Service.TCDCMiniTypeAPI.showTCDCMiniType(id);
    },
    saveMiniType({commit},{id,data}){
      if(id){
        return Service.TCDCMiniTypeAPI.updateTCDCMiniType(id,data);
      }else{
        return Service.TCDCMiniTypeAPI.createTCDCMiniType(data);
      }
    },
    deleteMiniType({commit},id){
      return Service.TCDCMiniTypeAPI.deleteTCDCMiniType(id);
    },
    setFormMiniType({commit},res){
      commit('SET_FORM',res);
    },
    clearFormData({commit}){
    commit('CLEAR_FORM_DATA');
    }
  },
}
export default MiniType
